import React from 'react';
import { StyledCloseBtn } from './styled';
import { CloseOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { DIMENSION_LIMIT } from '@store/trends/base/reducer';
import { useDimensionOperations } from '../hooks/useDimensionOperations';

function RemoveDimension({ dimension, disabled = false }) {
  const { selectedDimensions, removeDimension } = useDimensionOperations();

  const handleClose = () => {
    if (selectedDimensions.length > DIMENSION_LIMIT.min) {
      removeDimension(dimension);
    } else {
      message.warning(`Reached minimum limit of ${DIMENSION_LIMIT.min}`);
    }
  };

  return (
    <StyledCloseBtn
      className="remove-dimension-btn"
      type="text"
      icon={<CloseOutlined />}
      onClick={handleClose}
      size="small"
      disabled={disabled}
    />
  );
}

export default RemoveDimension;
